<template>
  <div class="layout 333">
    <div v-wechat-title="($route.meta.title = docTitle)"></div>
    <div class="bg_img">
      <div class="bg_mask"></div>
      <img v-if="bgUrl" :src="bgUrl" />
      <img v-else src="@assets/img/empty.png" />
    </div>
    <div class="home_wrap">
      <div v-for="(item, index) in webHomeModulesJsonEn" :key="'component-' + index">
        <searchBar @search="openSearch = true" :backgroundColor="backgroundColor" :placeholder="placeholder" :isDown="isDown" v-if="item.index === 0"></searchBar>
        <exCard ref="exCard" v-if="item.index === 0" :power="item.power"></exCard>
        <navTab v-if="item.index === 1 && item.power[0].open"></navTab>
        <adveBanner v-if="item.index === 2 && item.power[0].open"></adveBanner>
        <!-- <exLiveTool v-show="exhibitionConfig && exhibitionConfig.feature.enabledSpecialLive" ></exLiveTool> -->

        <exCompany v-show="exhibitionConfig && exhibitionConfig.feature.enabledBrandExhibitor" v-if="item.index === 3 && item.power[0].open" :rule="item.rule"></exCompany>
        <hotPro v-if="item.index === 4 && item.power[0].open" :rule="item.rule"></hotPro>
        <!-- <nearEx ref="nearEx" v-show="exhibitionConfig && exhibitionConfig.feature.enabledNearbyExhibitor"></nearEx> -->
        <togetherAct ref="togetherAct" v-show="exhibitionConfig && exhibitionConfig.feature.enabledConcurrentActivity" v-if="item.index === 5 && item.power[0].open" :rule="item.rule"></togetherAct>
        <!-- <exJoin></exJoin> -->
        <exTabList ref="exTabList" v-show="exhibitionConfig && exhibitionConfig.feature.enabledRecommendForYou" v-if="item.index === 6 && item.power[0].open"></exTabList>
        <news v-if="item.index === 7 && item.power[0].open"></news>
        <videoList v-if="item.index === 8 && item.power[0].open"></videoList>
      </div>
    </div>
    <exTool @shareClick="shareClick" :isFX="true"></exTool>
    <layoutFooter></layoutFooter>
    <!-- 热门搜索 -->
    <searchPage :show="openSearch" :placeholder="placeholder" :type="rankingType" @callback="setSearch" ref="search"></searchPage>
  </div>
</template>

<script>
import layoutFooter from "@components/layout-footer";
import searchBar from "@components/searchBar/index";
import exCard from "./components/ex-card";
import navTab from "./components/navTab";
import news from "./components/news";
import exCompany from "./components/ex-company";
import exJoin from "./components/ex-join";
import nearEx from "./components/near-ex";
import hotPro from "./components/hot-pro";
import togetherAct from "./components/together-act";
import exTabList from "./components/ex-tab-list";
import exTool from "./components/ex-tool";
import exLiveTool from "./components/ex-live-tool";
import searchPage from "@/components/searchPage"; // 搜索页
import adveBanner from "./components/adve-banner";
import videoList from "./components/video-list";
import { mapGetters } from "vuex";
export default {
  name: "home",
  data() {
    return {
      openSearch: false,
      exInfoIsOk: false, //展会信息是否加载完成
      bannersIsOk: false, //展会banner加载完成
      supplyIsOk: false, //供需加载完成
      adveIsOk: false,
      exLiveIsOk: false, //专题直播加载完成
      compListIsOk: false, //品牌展商加载完成
      backgroundColor: "rgba(255,255,255,0)", //头部背景图
      isDown: false,
      bgUrl: "",
      scroll_: null,
      docTitle: "Home",
      rankingType: "CompInfo", // 默认显示展商
      searchType: 0, // 搜索类型
      placeholder: "Exhibitors",

      arr: [
        {
          index: 0,
          title: "展会数据",
          power: [
            {
              title: "浏览人数",
              open: true,
            },
            {
              title: "浏览量",
              open: true,
            },
          ],
          default: true,
          open: true,
        },
        {
          index: 1,
          title: "快捷入口",
          power: [
            {
              title: "快捷入口",
              open: true,
            },
          ],
          default: false,
          open: false,
        },
        {
          index: 2,
          title: "轮播",
          power: [
            {
              title: "轮播",
              open: true,
            },
          ],
          default: false,
          open: false,
        },
        {
          index: 3,
          title: "品牌展商",
          power: [
            {
              title: "品牌展商",
              open: true,
            },
          ],
          default: false,
          open: false,
          rule: {
            lineRule: [
              { value: "1/3", label: "1行3列" },
              { value: "1/4", label: "1行4列" },
              { value: "2/3", label: "2行3列" },
              { value: "2/4", label: "2行4列" },
            ],
            line: "1/3", // 1/3 1行三列； 1/4 1行四列； 2/3 2行3列；2/4 2行4列
          },
        },
        {
          index: 4,
          title: "热搜产品",
          power: [
            {
              title: "热搜产品",
              open: true,
            },
          ],
          default: false,
          open: false,
          rule: {
            lineRule: [
              { value: "1/2", label: "1行2列" },
              { value: "1/3", label: "1行3列" },
              { value: "2/2", label: "2行2列" },
              { value: "2/3", label: "2行3列" },
            ],
            line: "1/2", // 1/3 1行三列； 1/4 1行四列； 2/3 2行3列；2/4 2行4列
          },
        },
        {
          index: 5,
          title: "同期活动",
          power: [
            {
              title: "同期活动",
              open: true,
            },
          ],
          default: false,
          open: false,
          rule: {
            lineRule: [
              { value: "1/2", label: "1行2列" },
              { value: "1/3", label: "1行3列" },
              { value: "2/2", label: "2行2列" },
              { value: "2/3", label: "2行3列" },
            ],
            line: "1/2", // 1/3 1行三列； 1/4 1行四列； 2/3 2行3列；2/4 2行4列
          },
        },
        {
          index: 6,
          title: "为您推荐",
          power: [
            {
              title: "为您推荐",
              open: true,
            },
          ],
          default: false,
          open: false,
        },
        {
          index: 7,
          title: "咨询头条",
          power: [
            {
              title: "咨询头条",
              open: true,
            },
          ],
          default: false,
          open: false,
        },
        {
          index: 8,
          title: "精彩视频",
          power: [
            {
              title: "精彩视频",
              open: true,
            },
          ],
          default: false,
          open: false,
        },
      ],
    };
  },
  components: {
    layoutFooter,
    searchBar,
    exCard,
    navTab,
    exLiveTool,
    news,
    exJoin,
    exCompany,
    nearEx,
    adveBanner,
    togetherAct,
    hotPro,
    exTool,
    exTabList,
    searchPage,
    videoList,
  },
  computed: {
    ...mapGetters({
      exhibitionInfo: "getExhibitionInfo",
      exhibitionId: "getExhibitionId",
      exhibitionConfig: "getExhibitionConfig",
      userId: "getUserId",
    }),
    webHomeModulesJsonEn() {
      // 是否开启展商显示数据的限制
      let arr = null;
      if (
        this.exhibitionConfig &&
        this.exhibitionConfig.display &&
        this.exhibitionConfig.display.webHomeModulesJsonEn
      ) {
        arr = JSON.parse(this.exhibitionConfig.display.webHomeModulesJsonEn);
      }
      return arr || this.arr;
    },
  },
  created() {
    this.init();
  },
  mounted() {
    this.$Bus.$on("bannerChange", (imgUrl) => {
      this.bgUrl = imgUrl;
    });
    this.scroll_ = () => {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let apl = (scrollTop * 0.0215).toFixed(2);
      if (Math.abs(apl) > 0.99) {
        this.backgroundColor = "rgba(255,255,255,1)";
        this.isDown = true;
      } else if (Math.abs(apl) > 0.1) {
        this.backgroundColor = `rgba(255,255,255,${Math.abs(apl)})`;
        this.isDown = true;
      } else {
        this.backgroundColor = `rgba(255,255,255,0)`;
        this.isDown = false;
      }
    };
    window.addEventListener("scroll", this.scroll_);
  },
  beforeDestroy() {
    if (this.scroll_) {
      window.removeEventListener("scroll", this.scroll_);
    }
    this.$Bus.$off("bannerChange");
  },
  methods: {
    async init() {
      let exhibitionId = this.$route.params.id;
      this.$store.commit("setExhibitionId", exhibitionId);
      await this.$Myapollo.getExhibitionInfo(this, exhibitionId, this.userId);
      console.log(this.exhibitionInfo, "this.exhibitionInfo----");
      console.log(this.exhibitionConfig, "this.exhibitionConfig----");
      
      this.docTitle =
        this.exhibitionInfo.exhibition && this.exhibitionInfo.exhibition.nameEn
          ? this.exhibitionInfo.exhibition.nameEn
          : "Home";
      if (this.$refs.exTabList) {
        this.$refs.exTabList[0].init();
      }
      if (this.$refs.togetherAct) {
        this.$refs.togetherAct[0].init();
      }
    },
    setSearch(e) {
      // 设置搜索值
      this.openSearch = false;
      this.searchText = e.txt;
      this.searchType = e.type; // 0为输入搜索，1为展馆，2为类别
      this.$store.commit("setSearch", this.searchText);
      if (this.searchText) {
        this.$router.push(
          `/exhibition/${this.exhibitionId}?search=${this.searchText}&searchType=${this.searchType}`
        );
      }
    },
    shareClick() {
      if (this.$refs.exCard && this.$refs.exCard[0]) {
        this.$refs.exCard[0].share();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.layout {
  min-height: 100vh;
  position: relative;
  background-size: contain;
  padding-bottom: 55px;
  padding-top: 0.93rem;
  background: #fff;
  .home_wrap {
    position: relative;
    z-index: 1;
  }
  .bg_img {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    height: 4.6rem;
    width: 100%;
    overflow: hidden;
    border-radius: 0 0 100% 100% / 0% 0% 10% 10%;
    .bg_mask {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      background: rgba($color: #000, $alpha: 0.2);
    }
    img {
      height: 100%;
      width: 100%;
      display: block;
      filter: blur(5px);
      transform: scale(1.1);
    }
  }
}
</style>
